import declare from "dojo/_base/declare";
import config from "csi/config";
import Widget from "csi/form/Widget";
import xml from "csi/xml";

const PRODUCT_HIERARCHY = "ProductHierarchy";
const PRODUCT_TYPE = "ProductType";
const SUBTYPE = "Subtype";

const ProductHierarchyForm = declare(Widget, {

	/** @property {string} productType - type of product shown in view */
	productType: "",

	/**
	 * @override
	 * Filter to remove subtypes that don't have the correct ProductType for current view
	 */
	getFieldStore(field, value) {
		if (field.getControlName() === SUBTYPE && !this.isEdit()) {
			const productTypeEnum = this.productType ? xml.enumCreate(PRODUCT_TYPE, this.productType) : null;
			if (productTypeEnum) {
				return config.getSubtypeStore(PRODUCT_HIERARCHY, (subtypeSettings) => subtypeSettings.ApplicableProductTypes.includes(productTypeEnum));
			} else {
				return config.getSubtypeStore(PRODUCT_HIERARCHY);
			}
		}

		return this.inherited(arguments);
	},
});

export = ProductHierarchyForm;